import {originApiSlice} from './open-api/origin-api-slice.ts';

export const apiReducers = {
  [originApiSlice.reducerPath]: originApiSlice.reducer,
};

export const apiMiddleware = [
  originApiSlice.middleware,
];
